import { handleActions, combineActions } from 'redux-actions'
import { fromJS, OrderedSet, Set } from 'immutable'

import {
  fetchOrgValues,
  setOrgValuesView,
  saveOrgValue,
  deleteOrgValue,
  valuesSelectPage,
  valuesSortBy,
  setPending,
  setEditForm,
} from './actions'
import { Value, initialState } from './records'

const createValue = value => {
  const proTracksCount = (Array.isArray(value.proTracks) && value.proTracks.length) || 0
  const proTracks =
    (Array.isArray(value.proTracks) &&
      Set(value.proTracks.map(proTrack => (typeof proTrack === 'number' ? proTrack : proTrack.id)))) ||
    Set()
  const globalValueField = value.globalValue.name
  return new Value({
    ...value,
    proTracks,
    proTracksCount,
    globalValueField,
  })
}

const handleFetchSuccess = (state, { payload }) => {
  let ids = OrderedSet()
  return state
    .set(
      'all',
      payload.data.reduce((values, value) => {
        ids = ids.add(value.id)
        return values.set(value.id.toString(), createValue(value))
      }, fromJS({}))
    )
    .set('error', null)
    .set('ids', ids)
    .setIn(['loaded', 'getAll'], true)
    .setIn(['pending', 'getAll'], false)
}

const handleSetOrgValuesView = (state, { payload }) => {
  return state.set('view', payload.toString())
}

const handleDeleteSuccess = (state, { payload, meta: { valueId } }) => {
  const ids = state.get('ids').delete(valueId)
  let currentPage = state.getIn(['pagination', 'current'])
  const perPage = state.getIn(['pagination', 'perPage'])
  if (currentPage > Math.ceil(ids.size / perPage) - 1) {
    currentPage--
  }
  return state
    .deleteIn(['all', valueId.toString()])
    .set('ids', ids)
    .setIn(['pagination', 'current'], currentPage)
    .set('error', null)
    .setIn(['pending', 'delete'], false)
}

const handleCreateSuccess = (state, { payload }) => {
  const value = payload.data
  const { id } = value
  const newIds = OrderedSet([id])
  const ids = newIds.concat(state.get('ids'))
  return state
    .set('ids', ids)
    .setIn(['all', id.toString()], createValue(value))
    .setIn(['pending', 'post'], false)
    .setIn(['pagination', 'current'], 0)
}

const handleValuesSelectPage = (state, { payload }) => {
  return state.setIn(['pagination', 'current'], payload.page)
}

const handleValuesSortBy = (state, { payload }) => {
  return state.setIn(['sort', 'by'], payload.by).setIn(['sort', 'desc'], payload.desc)
}

const handleValuesSetPending = (state, { payload }) => {
  const { field, value } = payload
  return state.setIn(['pending', field], value)
}

const handleFetchFail = state => {
  return state
    .setIn(['pending', 'getAll'], false)
    .setIn(['pending', 'post'], false)
    .setIn(['pending', 'delete'], false)
    .setIn(['pending', 'patch'], false)
}

const handleValuesChangeEditForm = state => {
  return state.set('editForm', !state.get('editForm'))
}

export default handleActions(
  {
    [fetchOrgValues.success]: handleFetchSuccess,
    [setOrgValuesView]: handleSetOrgValuesView,
    [saveOrgValue.success]: handleCreateSuccess,
    [deleteOrgValue.success]: handleDeleteSuccess,
    [valuesSelectPage]: handleValuesSelectPage,
    [valuesSortBy]: handleValuesSortBy,
    [setPending]: handleValuesSetPending,
    [combineActions(fetchOrgValues.fail, saveOrgValue.fail, deleteOrgValue.fail)]: handleFetchFail,
    [setEditForm]: handleValuesChangeEditForm,
  },
  initialState
)
